export { default } from './secured-by-footprint';
